import React, { Component } from 'react'
import { Button } from 'reactstrap'
import { message } from 'antd'
import MarkWrongDesignModal from './MarkWrongDesignModal'
import MarkErrorsModal from './MarkErrorsModal'
import { pushNewItemHistory } from '../../../services/api/apiItemHistory'
import getHistory from '../../../getHistory'

class MarkWrongDesign extends Component {
    state = {
        isOpen: false,
        showModal: false,
    }

    _handleClose = () => {
        this.setState({
            isOpen: false,
        })
    }

    _handleOpen = e => {
        e.preventDefault()

        this.setState({
            isOpen: true
        })
    }

    _handleOpenModal = () => {
        this.setState({
            showModal: true,
        })
    }

    _handleCloseModal = () => {
        this.setState({
            showModal: false,
        })
    }

    _markQC = async () => {
        const { id, reset, onChangeId } = this.props
        const history = getHistory()
        try {
            const { success, data, message: mess } = await pushNewItemHistory(id, {
                event_key: 'scan_to_check',
                event_description: 'Scan QR to check product quality.'
            })
            if (!success) {
                return message.error(mess)
            }
            reset()
            message.success(`Item #${id} đã được đánh dấu hoàn thành!`)
            onChangeId('')
            history.push("/check")
        } catch (error) {
            message.error(error.message)
        }
    }

    render() {
        const { id, reset, onChangeId, product } = this.props
        const { status } = { ...product }
        const { isOpen, showModal } = this.state

        return (
            <div className="d-flex justify-content-center">
                <div className="text-center mb-3">
                    {/* <Button
                        color="danger"
                        className='ButtonWrongDesign'
                        onClick={this._handleOpen}
                    >
                        Sai Design
                    </Button> */}
                    <Button
                        color="warning"
                        className='ButtonWrongDesign'
                        onClick={this._handleOpenModal}
                    >
                        Đánh dấu lỗi
                    </Button>
                    {status === 'completed' &&
                        <Button
                            color="success"
                            className='ButtonWrongDesign ml-5'
                            onClick={this._markQC}
                        >
                            Đánh dấu hoàn thành
                        </Button>
                    }
                    {
                        isOpen && (
                            <MarkWrongDesignModal id={id} onClose={this._handleClose} isOpen={isOpen} />
                        )
                    }
                    {
                        showModal && (
                            <MarkErrorsModal id={id} onClose={this._handleCloseModal} reset={reset} onChangeId={onChangeId} isOpen={showModal} />
                        )
                    }
                </div>
            </div>
        )
    }

}

export default MarkWrongDesign